export default "__VITE_ASSET__CdXZfWQq__"